import BarcodeReaderInput   from '@/components/fields/barcode-reader-input.vue';
import ProductSearch        from './components/product-search.vue';

import { validationMixin } from 'vuelidate';
import { required, requiredIf, maxLength} from 'vuelidate/lib/validators';

// This is a description of the component
// OrderCreate : ___
// @group OrderCreate
export default {
    components : {
        ProductSearch,
        BarcodeReaderInput,
        // ProductTraces
    },

    mixins: [validationMixin],
    validations: {
        checkboxNoSerialNumber : {
            checked (val) {
                let barcode = this.$refs.barcodeReaderInput.getValue();
                if (barcode && barcode.length > 0 && val) {
                    return true;
                } else if (!val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        selectProductPackage: { required },
        checkboxNoTraces : {
            checked (val) {
                if (this.checkboxProductTraces.length > 0 || this.othersProductTraces.length > 0 || val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        checkboxProductTraces : {
            required : requiredIf(function (model) {
                if (this.othersProductTraces.length > 0 || this.checkboxNoTraces || this.checkboxProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        othersProductTraces    : {
            required : requiredIf(function (model) {
                if (this.checkboxProductTraces.length > 0 || this.checkboxNoTraces || this.othersProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
            maxLength : maxLength(200)
        },
        checkboxNoAccessoires : {
            checked (val) {
                if (this.checkboxesProductAccessoires.length > 0 || this.othersProductAccessoires.length > 0 || val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        checkboxesProductAccessoires : {
            required : requiredIf(function (model) {
                if (this.othersProductAccessoires.length > 0 || this.checkboxNoAccessoires || this.checkboxesProductAccessoires.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        othersProductAccessoires    : {
            required : requiredIf(function (model) {
                if (this.checkboxesProductAccessoires.length > 0 || this.checkboxNoAccessoires || this.othersProductAccessoires.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
            maxLength : maxLength(200)
        },
        panelProductInformation : [
            'checkboxNoSerialNumber',
            'selectProductPackage'
        ],
        panelProductTraces      : [
            'checkboxNoTraces',
            'checkboxProductTraces',
            'othersProductTraces'
        ],
        panelProductAccessoires : [
            'checkboxNoAccessoires',
            'checkboxesProductAccessoires',
            'othersProductAccessoires'
        ],
        stepProductData         : [
            'panelProductInformation',
            'panelProductTraces',
            'panelProductAccessoires'
        ]
    },
    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data () {
        return {
            //panels
            // defines wich panel will be opend on start
            // 0 - ProductInformation
            // 1 - ProductTraces
            // 2 - ProductAccessoires
            panelsProductData       : [0, 1, 2],
            panelProductInformation : null,
            panelProductTraces      : null,
            panelProductAccessoires : null,

            //product search input field
            selectedProduct         : null,
            isUpdating              : false,

            showProductInfos        : false,
            selectedProductInfos    : [],

            //Fields
            fieldSerialNumber       : "",
            fieldSerialNumberHint   : "capture",
            checkboxNoSerialNumber  : true,
            productPackageOptions   : [
                {
                    id      : 'UVP',
                    label   : 'uvp',
                },{
                    id      : 'OVP',
                    label   : 'ovp',
                },{
                    id      : 'FVP',
                    label   : 'fvp'
                }
            ],
            selectProductPackage    : "",

            checkboxProductTraces   : [],
            othersProductTraces     : "",
            checkboxNoTraces        : false,

            //get this data from db request
            productTracesOptions: [
                { label: 'Kratzspuren am Gehäuse', id : '000'},
                { label: 'Riss im Display',        id : '001'},
                { label: 'Farbschaden',            id : '002'},
                { label: 'Delle in Gehäuse',       id : '003'},
                { label: 'Riss im Gehäuse',        id : '004'}
            ],

            //accessoires
            checkboxesProductAccessoires  : [],
            othersProductAccessoires    : "",
            checkboxNoAccessoires        : false,

            //get this data from db request
            productAccessoiresOptions   : [
                { label: 'Monitor',                       id : '010'},
                { label: 'Lautsprecher',                  id : '011'},
                { label: 'Batterie/Akku',                 id : '012'},
                { label: 'Netzgeräte',                    id : '013'},
                { label: 'originalverpackt und komplett', id : '014'},
                { label: 'ohne Zubehör',                  id : '015'},
                { label: 'Ladegerät',                     id : '016'},
                { label: 'Akku',                          id : '017'}
            ],
        };
    },
    methods: {
        onSerialNumberCheckboxClick() {
            if (!this.checkboxNoSerialNumber) {
                this.$refs.barcodeReaderInput.setValue('');
            }
        },
        checkSerialNumberIfHintOrNot() {
            if(this.checkboxNoSerialNumber) {
                this.fieldSerialNumberHint = "scan";
                return false;
            }
            this.fieldSerialNumberHint = "not-available";
            return true;
        },
        onCheckboxNoTracesChange() {
            this.validateStep();
            this.checkboxProductTraces = [];
            this.othersProductTraces = "";
        },
        onCheckboxNoAccessoiresChange() {
            this.validateStep();
            this.checkboxesProductAccessoires = [];
            this.othersProductAccessoires = "";
        },
        onSelectProduct(product) {
            if (product != null) {
                // this.stepValid = true;
                this.$emit('step-product-data-is-valid');
                this.$emit('on-product-select-change', product);

                //load product details
                this.showProductInfos = true;
                this.selectedProduct = product;
                this.selectedProductInfos = [];
                let productInfos = {};
                productInfos =  {
                    'detail'    : product.inventorynumber,
                    'label'     : 'inventory-number'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.eannumber,
                    'label'     : 'ean-number'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.brandName,
                    'label'     : 'brand-name'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.name[this.$i18n.locale],
                    'label'     : 'model-name'
                };
                this.selectedProductInfos.push(productInfos);
            } else {
                this.showProductInfos       = false;
            }
        },
        onClearSelectedProduct() {
            this.resetValues();
            this.$v.$reset();
        },
        resetValues() {
            this.selectedProductInfos   = [];
            this.showProductInfos       = false;

            this.$refs.barcodeReaderInput.setValue();
            this.checkboxNoSerialNumber = false;
            this.selectProductPackage   = "";

            this.checkboxProductTraces  = [];
            this.othersProductTraces    = "";
            this.checkboxNoTraces       = false;
        },
        validateAll() {
            //validate all fields
            this.$v.stepProductData.$touch();
            this.$refs.barcodeReaderInput.validate();

            let errorKeys = [];

            //panelProductInformation (Key = 0)
            if (this.$v.panelProductInformation.$anyError) {
                errorKeys.push(0); // push key to errorKey to expand panel
            }

            //panelProductTracesKey (Key = 1)
            if (this.$v.panelProductTraces.$anyError) {
                errorKeys.push(1);  // push key to errorKey to expand panel
            }

            //panelProductTracesKey (Key = 2)
            if (this.$v.panelProductAccessoires.$anyError) {
                errorKeys.push(2);  // push key to errorKey to expand panel
            }

            this.panelsProductData = [];
            if (errorKeys.length > 0) {
                this.panelsProductData = errorKeys;
                return false;
            }
            return true;
        },
        validateSelectedProduct() {
            if (!this.$refs.productSearch.validate()) {
                this.$emit('step-product-data-has-errors');
                return false;
            }
            this.$emit('step-product-data-is-valid');
            return true;
        },
        validateStep() {
            if (this.validateSelectedProduct()){
                return false;
            }
            if(!this.$v.stepProductData.$dirty) {
                return;
            } else {
                this.$v.stepProductData.$touch();
            }

        },
        getStepData() {
            let ret = {};
            if (!this.selectedProduct) {
                return ret;
            }
            ret.productBrand                = this.selectedProduct.brandName;
            ret.productModel                = this.selectedProduct.name;
            ret.productSerialNumber         = this.$refs.barcodeReaderInput.getValue();
            ret.productPackage              = this.selectProductPackage;
            ret.productTraces               = this.checkboxProductTraces;
            ret.othersProductTraces         = this.othersProductTraces;
            ret.productAccessoires          = this.checkboxesProductAccessoires;
            ret.othersProductAccessoires    = this.othersProductAccessoires;
            return ret;
        },
        getProductTraces() {
            let ret = [];
            let me = this;
            this.checkboxProductTraces.forEach(function(trace) {
                ret.push(trace.id);
            });
            return ret;
        },
        getProductAccessoires() {
            let ret = [];
            let me = this;
            this.checkboxesProductAccessoires.forEach(function(accessoire) {
                ret.push(accessoire.id);
            });
            return ret;
        },
        getStepSubmitData() {
            let ret = {};
            if (!this.selectedProduct) {
                return ret;
            }

            ret.inventoryNumber      = this.selectedProduct.inventorynumber;
            ret.dummyBrandName       = "";
            ret.dummyEanNumber       = "";
            ret.dummyInventoryNumber = "";
            ret.dummyName            = "";
            ret.isDummy              = false;
            ret.serialNumber         = this.$refs.barcodeReaderInput.getValue();
            ret.serialNumberNone     = this.checkboxNoSerialNumber;
            ret.packing              = this.selectProductPackage.id;

            var traces = {};
            traces.tracesNone       = this.checkboxNoTraces;
            traces.traces           = this.getProductTraces();
            traces.tracesOtherText  = this.othersProductTraces;
            ret.traces  = traces;

            var accessories = {};
            accessories.accessoriesNone         = this.checkboxNoAccessoires;
            accessories.accessories             = this.getProductAccessoires();
            accessories.accessoriesOtherText    = this.othersProductTraces;
            ret.accessories  = accessories;

            return ret;
        },
    },
    watch: {
        '$v.stepProductData.$anyError' : function(errors) {
            if (errors) {
                console.error('is valid 1');
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('step-product-data-has-errors');
            } else {

                // console.error('has errors 1');
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('step-product-data-is-valid');
            }
        },
        '$v.stepProductData.$dirty' : function(dirty) {
            if (!dirty && !this.$v.stepProductData.$anyError) {
                // console.error('is valid 2');
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('step-product-data-is-valid');
            } else {
                if (dirty && this.$v.stepProductData.$anyError) {
                // console.error('has errors 2');
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('step-product-data-has-errors');
                }
            }
        },
    },
    computed: {
        //push errors for if case
        selectedProductErrors () {
            const errors = [];
            if (!this.$v.selectedProduct.$dirty) {
                return errors;
            }
            if (!this.$v.selectedProduct.required) {
                errors.push('PselectedProduc is required');
            }
            return errors;
        },
        checkboxNoSerialNumberErrors () {
            const errors = [];
            if (!this.$v.checkboxNoSerialNumber.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoSerialNumber.checked) {
                errors.push('checkboxNoSerialNumber is required.');
            }
            return errors;
        },
        selectProductPackageErrors () {
            const errors = [];
            if (!this.$v.selectProductPackage.$dirty) {
                return errors;
            }
            if(!this.$v.selectProductPackage.required) {
                errors.push('Package Select is required');
            }
            return errors;
        },
        checkboxNoTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxNoTraces.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoTraces.checked) {
                errors.push('checkboxNoTraces is required.');
            }
            return errors;
        },
        checkboxProductTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxProductTraces.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxProductTraces.required) {
                errors.push('checkboxProductTraces is required.');
            }
            return errors;
        },
        othersProductTracesErrors () {
            const errors = [];
            if (!this.$v.othersProductTraces.$dirty) {
                return errors;
            }
            if(!this.$v.othersProductTraces.maxLength) {
                errors.push('othersProductTraces must be at most 50 characters long');
            }
            if(!this.$v.othersProductTraces.required) {
                errors.push('');
            }
            return errors;
        },
        checkboxNoAccessoiresErrors () {
            const errors = [];
            if (!this.$v.checkboxNoAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoAccessoires.checked) {
                errors.push('');
            }
            return errors;
        },
        checkboxesProductAccessoiresErrors () {
            const errors = [];
            if (!this.$v.checkboxesProductAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxesProductAccessoires.required) {
                errors.push('');
            }
            return errors;
        },
        othersProductAccessoiresErrors () {
            const errors = [];
            if (!this.$v.othersProductAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.othersProductAccessoires.maxLength) {
                errors.push('othersProductAccessoires must be at most 50 characters long');
            }
            if(!this.$v.othersProductAccessoires.required) {
                errors.push('');
            }
            return errors;
        },
    },
};
